import { createTheme } from '../utils/create-theme';
export var JUSTICE_THEME = createTheme('justice', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#163884',
      primaryDarker: '#11213E',
      primaryLight: '#D4D9E6',
      primaryLighter: '#94a1c0',
      primaryBright: '#2F5BAD',
      primaryVeryLight: '#D5E0F5',
      textTitle: '#172C54',
      link: '#163884',
      linkHover: '#E1A449',
      navigationActive: '#D48700',
      accentDark: '#11213E',
      accentLight: '#D4D9E6'
    }
  },
  dark: {
    color: {
      linkHover: '#D48700'
    }
  }
});
export default JUSTICE_THEME;